/** we need this file/object to resolve circular dependency with some of export variables in model.ts */
export const socialAccountConnectEffectorRefs: SocialAccountConnectEffectorRefs =
  {};

interface SocialAccountConnectEffectorRefs {
  openSocialAccountConnectDialog?: () => void;
  openHowdyGoDemoDialog?: () => void;
  disableMainDialogGuard?: () => void;
  updateMaxAllowed?: (count: number) => void;
}
